module.exports = __webpack_public_path__ + "img/actn.f9cc3bc4.svg";